export default __webpack_public_path__ + "static/media/vacations-permissions.53a4932e.jpg";